import React, { useEffect, useState, ReactNode, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber } from 'lodash';
import { init } from 'echarts';

import Color from '@tool/color';
import moHumanIndustry from '../store/industry';
import { round } from 'mathjs';

interface IProps { }
interface IState { }
let chart: any = null;

const IndustryChart = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const industryRef = useRef<any>(null);
  const { industryList } = moHumanIndustry;

  const xData = useMemo(() => {
    const xList: any = [];
    const costList: any = [];
    const profitList: any = [];
    const revenueList: any = [];
    industryList?.multi_indicator?.detail?.forEach((res: any) => {
      xList.push(res.label);
      costList.push(res.cost_per_staff_ratio);
      profitList.push(res.profit_per_staff_ratio);
      revenueList.push(res.revenue_per_staff_ratio);
    });
    return {
      xList, costList, profitList, revenueList,
    };
  }, [industryList]);

  const colorList = [Color.primary, Color.two, Color.secondary];

  const render = () => {
    if (chart) chart.dispose();
    chart = init(industryRef.current);
    const option = {
      color: colorList,
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
          label: { show: true },
        },
        formatter: (parmes: any) => {
          let htl = `<p  style="font-family: 'PingFang SC'">${parmes[0].name}</p>`;
          parmes?.forEach((element: any, i: number) => {
            htl += `<p style="margin-top:10px;display:flex;
                         justify-content: flex-start;align-items: center;">
                      <span
                        style="display:inline-block;
                        width:10px;height:10px;background:${colorList[element.seriesIndex]};
                        border-radius:50%;margin-right:5px">
                      </span>
                      <span style="font-family: 'PingFang SC'">${element.seriesName}</span>
                      <span style="margin:0 15px"></span>
                      <span style="font-family: 'Roboto';padding-top:4px;flex:1;text-align:right">
                        ${isNumber(element.value) ? `${round(element.value * 100, 1)}%` : '-'}
                      </span>
                   </p>`;
          });
          return htl;
        },
      },
      legend: {
        data: ['人均营业收入变化率', '人均净利润变化率', '人均薪酬成本变化率'],
        bottom: 0,
        icon: 'circle',
      },
      grid: {
        left: 30,
        right: 10,
        bottom: 45,
        top: 10,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: xData.xList,
        axisTick: { show: false },
        axisLine: {
          lineStyle: { color: Color.ccc },
        },
        axisLabel: {
          color: Color.blackColor(0.85),
        },
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: false,
          lineStyle: { color: Color.ccc },
        },
        axisTick: { show: false },
        axisLabel: {
          show: true,
          formatter: (val: number) => {
            if (val === 0) return 0;
            return `${round(val * 100, 1)}`;
          },
          fontSize: 10,
          color: Color.blackColor(0.5),
          // fontFamily: 'Roboto',
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: Color.blackColor(0.08),
            width: 1,
            type: 'dashed',
          },
        },
      },
      series: [
        {
          name: '人均营业收入变化率',
          type: 'line',
          data: xData.revenueList,
        },
        {
          name: '人均净利润变化率',
          type: 'line',
          data: xData.profitList,
        },
        {
          name: '人均薪酬成本变化率',
          type: 'line',
          data: xData.costList,
        },
      ],
    };
    chart.setOption(option, true);
  };

  useEffect(() => {
    render();
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  }, [industryList]);

  return (
    <section className="industry-chart-warp" ref={industryRef} />
  );
};

export default observer(IndustryChart);
